import type { SVGProps } from "react";
const SvgArrowRight01Sharp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m7.5 15 4.41-4.41c.278-.278.417-.417.417-.59s-.139-.311-.416-.59L7.5 5"
    />
  </svg>
);
export default SvgArrowRight01Sharp;
